import React from 'react';
import { useIntl } from 'react-intl';

import {
  Container,
  CenterSection,
  ErrorIconCircle,
  Title,
  TextStack,
  Strong,
} from './styles';
import { CheckErrorIcon } from '../../../components/Icons';
import { Card, CardBody, NextStepsTitle, StepItem, Steps } from '../VerificationFailed/styles';

function LinkExpired() {
  const intl = useIntl();

  return (
    <Container>
      <CenterSection>
        {/* Error Icon */}
        <ErrorIconCircle>
          <CheckErrorIcon />
        </ErrorIconCircle>

        {/* Error Message */}
        <div style={{ marginBottom: '2rem' }}>
          <Title>{intl.messages['expired.title']}</Title>
          <TextStack>
            {intl.messages['expired.sorry']}{' '}
            <Strong>{intl.messages['expired.sorry.bold']}.</Strong>
          </TextStack>
        </div>

        {/* Instructions Card */}
        <Card>
          <CardBody>
            <NextStepsTitle>
              {intl.messages['verificationFailed.nextSteps.title']}
            </NextStepsTitle>
            <Steps>
              <StepItem>
                {intl.messages['verificationFailed.nextSteps.step1']}{' '}
                <b>{intl.messages['verificationFailed.nextSteps.step1.1']}</b>{' '}
                {intl.messages['verificationFailed.nextSteps.step1.2']}
              </StepItem>
              <StepItem>
                {intl.messages['verificationFailed.nextSteps.step2']}
              </StepItem>
              <StepItem>
                {intl.messages['verificationFailed.nextSteps.step3']}
              </StepItem>
            </Steps>
          </CardBody>
        </Card>
      </CenterSection>
    </Container>
  );
}

export default LinkExpired;
